

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { DefaultShipMethodID, DefaultCountry } from 'src/app/constant';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class ShippingMethodService {

    constructor(public configService: ConfigService) {}

    getShippingMethodId(orderSubtotal: number, customerType: number, isAutoShip: boolean): string {
        // No free-shipping promos: the old "16" free-ship method is a DirectScale id
        // that does not exist in Pillars (calc service 500s on it) — T-0307.
        const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
        const shippingData = this.configService.commonData?.CountryCode?.[selectedCountry];
        return shippingData?.ShippingMethod || DefaultShipMethodID;
    }
}